import { useEffect, useRef } from 'react'
import { useStore } from 'jotai'
import { getCurrentChatInput, useSetChatInput } from '@renderer/chat'
import { useViewNavigation, viewDraftsAtom } from '../view-atoms'

/**
 * Per-history-entry draft persistence (ADR 0001): the chat input is one shared
 * field under every View, so on navigation the outgoing entry's unsent text is
 * stashed under its entry key and the incoming entry's draft (or an empty
 * input) is restored. Mount once at the sidepanel root.
 */
export function useViewDraftPersistence() {
  const { topEntryKey } = useViewNavigation()
  const setChatInput = useSetChatInput()
  const store = useStore()
  const previousKeyRef = useRef(topEntryKey)

  useEffect(() => {
    const previousKey = previousKeyRef.current
    if (previousKey === topEntryKey) {
      return
    }
    previousKeyRef.current = topEntryKey

    store.set(viewDraftsAtom, (drafts) => {
      const draft = getCurrentChatInput()
      if ((drafts[previousKey] ?? '') === draft) return drafts
      return { ...drafts, [previousKey]: draft }
    })
    setChatInput(store.get(viewDraftsAtom)[topEntryKey] ?? '')
  }, [topEntryKey, setChatInput, store])
}
